import { createSlice } from "@reduxjs/toolkit";
import { VerificationSteps } from "pages/VerificationPage/utils/constants";
import type { RootState } from "store";
import { onPatientSessionReset } from "store/slices/order";
import { IAccount } from "types/Account/Account";

interface IVerificationStateProps {
  verificationStep: VerificationSteps;
  accountInfo: IAccount;
}

const initialState: IVerificationStateProps = {
  verificationStep: VerificationSteps.DOB_AUTH,
  accountInfo: {} as IAccount,
};

export const verificationSlice = createSlice({
  name: "verification",
  initialState,
  reducers: {
    onVerificationStepChange: (
      state,
      action: { payload: { step: VerificationSteps } }
    ) => {
      state.verificationStep = action.payload.step;
    },
    onChangeAccountInfo: (
      state,
      action: { payload: { accountInfo: IAccount } }
    ) => {
      state.accountInfo = action.payload.accountInfo;
    },
  },
  // CLE-2181: the patient-session reset (dispatched by publicApi's 403 handler when an
  // order-bound token is rejected) must return the /receipt and /confirmation pages to their
  // DOB gate too. That reset was added to the order slice and wired into overviewStep /
  // orderUpdateStep / orderPayMoreStep, but VerificationPage renders off THIS slice's
  // verificationStep — so without this the receipt/confirmation pages kept rendering with a
  // cleared token, the next request 401'd, and the patient was hard-redirected to the staff
  // /login (and Receipt could crash rendering an empty order). Drop to the gate so DOBAuth
  // re-mints instead.
  extraReducers: (builder) => {
    builder.addCase(onPatientSessionReset, (state) => {
      state.verificationStep = VerificationSteps.DOB_AUTH;
    });
  },
});

export const { onVerificationStepChange, onChangeAccountInfo } =
  verificationSlice.actions;

export const verificationSelector = (state: RootState) =>
  state.verificationSlice;

export default verificationSlice.reducer;
